"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRODUCTION_NO_POWER = exports.PRODUCTION_HAS_POWER = exports.PRODUCTION_NO_INPUT = exports.PRODUCTION_OUTPUT_BLOCKED = exports.PRODUCTION_RUNNING = void 0;
exports.PRODUCTION_RUNNING = Symbol("RUNNING");
exports.PRODUCTION_OUTPUT_BLOCKED = Symbol("OUTPUT_BLOCKED");
exports.PRODUCTION_NO_INPUT = Symbol("NO_INPUT");
exports.PRODUCTION_HAS_POWER = Symbol("HAS_POWER");
exports.PRODUCTION_NO_POWER = Symbol("NO_POWER");
